import { render, staticRenderFns } from "./AcademicData.vue?vue&type=template&id=cdae92da&"
import script from "./AcademicData.vue?vue&type=script&lang=ts&"
export * from "./AcademicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdae92da')) {
      api.createRecord('cdae92da', component.options)
    } else {
      api.reload('cdae92da', component.options)
    }
    module.hot.accept("./AcademicData.vue?vue&type=template&id=cdae92da&", function () {
      api.rerender('cdae92da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/AcademicData.vue"
export default component.exports